module.exports = __webpack_public_path__ + "static/img/admin.ad065d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin.png
// module id = MCVb
// module chunks = 16